import React, { memo } from 'react';
import {
    StyledReserveReceiptStore,
    StyledOpeningHoursWrapper,
    StyledReceiptInfo,
    StyledReceiptStoreInfo,
    StyledReceiptMediumText,
} from './styled';
import { Link, Text } from '~/shared/components';
import { OpeningHoursTable } from '~/templates/pages/components/P180StorePage';
import { ReservationStoreSearchViewModel } from '~/lib/data-contract';
import { useTracking, useTranslation } from '~/shared/utils';
import { Spacer } from '~/theme';
import { useEffectOnce } from 'react-use';

type ReserveReceiptStoreProps = {
    pickupStore?: ReservationStoreSearchViewModel;
};

export const ReserveReceiptStore = memo(({ pickupStore }: ReserveReceiptStoreProps) => {
    const { translate } = useTranslation();
    const { trackProductReservation, trackStoreReservation } = useTracking();
    const { storeName, address, zipcode, city, phone, openingHours } = pickupStore || {};

    useEffectOnce(() => {
        trackProductReservation();
        if (storeName) {
            trackStoreReservation(storeName);
        }
    });

    return (
        <StyledReserveReceiptStore>
            <StyledReceiptInfo>
                <StyledReceiptStoreInfo>
                    <Text variant="display4" as="h2">
                        {storeName}
                    </Text>
                    <Spacer space="2" />
                    <StyledReceiptMediumText variant="bodySm">
                        {address},<br />
                        {zipcode} {city}
                    </StyledReceiptMediumText>
                    <Spacer space="1" />
                    {phone && (
                        <Text variant="bodySm">
                            {translate('reservation.receipt.phone')}{' '}
                            <Link href={`tel:${phone}`} type="plain">
                                <StyledReceiptMediumText variant="bodySm" as="span">
                                    {phone}
                                </StyledReceiptMediumText>
                            </Link>
                        </Text>
                    )}
                </StyledReceiptStoreInfo>
                <StyledOpeningHoursWrapper>
                    <OpeningHoursTable
                        textVariantCaption="bodySm"
                        textVariantContent="bodySm"
                        openingHours={openingHours}
                    />
                </StyledOpeningHoursWrapper>
            </StyledReceiptInfo>
        </StyledReserveReceiptStore>
    );
});
